import React, { useState, useEffect, use } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../App.css';
import { auth } from '../firebase/firebaseconfig';
import { onAuthStateChanged } from "firebase/auth";
import EmptyFrame from '../Assets/EmptyFrame.png';
import { db } from "../firebase/firebaseconfig";

import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,setDoc,
  getDoc,
} from "firebase/firestore";
export default function CustomCategory() {
  const [customType, setCustomType] = useState('');
  const [stickerFile, setStickerFile] = useState(null);
  const [stickerPreview, setStickerPreview] = useState(null);
  const [frameFile, setFrameFile] = useState(null);
  const [framePreview, setFramePreview] = useState(null);
  const [frameSize, setFrameSize] = useState('');
  const [productName, setProductName] = useState('');
  const [user, setUser] = useState(null);
const [cartt, setCartt] = useState([]);
const [seeimage, setSeeimage] = useState('');
const [exists, setExists] = useState(true);
  const navigate = useNavigate();

  // Listen for auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));
    return unsubscribe;
  }, []);





  // Compress image to Base64
const compressImage = (input, maxSizeKB = 350) => {
  console.log('Compressing image:', input);

  return new Promise((resolve, reject) => {
    let reader;

    if (typeof input === 'string') {
      // input is base64
      reader = { result: input };
      processImage(input);
    } else {
      // input is File or Blob
      reader = new FileReader();
      reader.readAsDataURL(input);
      reader.onload = () => processImage(reader.result);
      reader.onerror = reject;
    }

    function processImage(dataURL) {
      const img = new Image();
      img.src = dataURL;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        let width = img.width;
        let height = img.height;
        const maxWidth = 1920;
        const maxHeight = 1080;

        if (width > height && width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        } else if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        let quality = 0.9;
        let base64 = canvas.toDataURL('image/jpeg', quality);
        while (base64.length / 1024 > maxSizeKB && quality > 0.3) {
          quality -= 0.05;
          base64 = canvas.toDataURL('image/jpeg', quality);
        }

        resolve(base64);
      };
      img.onerror = reject;
    }
  });
};


  const base64ToBlob = (base64, mime = 'image/png') => {
    console.log('Converting Base64 to Blob:');
  const byteString = atob(base64.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mime });
}

useEffect(() => {
  if (!frameFile) {
    setFramePreview(null);
    setSeeimage('');
    return;
  }

  const processFrame = async () => {
    try {
      // compress uploaded file
      const compressedFrame = await compressImage(frameFile, 350);
      console.log('Compressed frame:', compressedFrame);
      setFramePreview(compressedFrame);
setSeeimage(compressedFrame);
    } catch (err) {
      console.error(err);
    }
  };

  processFrame();
}, [frameFile]);






useEffect(() => {
  if (seeimage) console.log('seeimage updated:', seeimage);
}, [seeimage]);




  // Sticker preview
  useEffect(() => {
    if (!stickerFile) return setStickerPreview(null);
    compressImage(stickerFile, 350).then(setStickerPreview).catch(console.error);
  }, [stickerFile]);

  // Frame preview
// useEffect(() => {
//   console.log('Frame file changed:');
//   if (!frameFile) return setFramePreview(null);

//   console.log('old :', framePreview);

//   compressImage(frameFile, 350)
//     .then((compressed) => {
//       console.log('new (compressed):', compressed); // this is the new Base64
//       setFramePreview(compressed);
//     })
//     .catch(console.error);

// }, [frameFile]);



  const generateHash = async (text) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
  
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
  
    const hashHex = hashArray
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  
    return hashHex;
  };
  
  




  // Add final product to cart
 const addFinalProductToCart = async () => {

  const image = customType === "sticker" ? stickerPreview : framePreview;
  const hashed = await generateHash(image);

  const category = customType === "sticker" ? "Stickers" : "Frames";

  const custom = {
    id: Math.random().toString(36).substring(2, 10),
    name: productName,
    category: category,
    price: customType === "sticker" ? 15 : (frameSize === "20x30" ? 250 : 350),
    hashedimg: hashed,
    image: image,
    size: customType === "sticker" ? null : frameSize,
    type: "custom",
    count: 1
  };
if(user){
  const q = query(collection(db, "Users"), where("User", "==", user.email));
  const snapshot = await getDocs(q);

  const dbuserdoc = snapshot.docs[0];
  const dbuser = dbuserdoc.data();
  const dbcart = dbuser.cart || [];

  const productExists = dbcart.some(
    (item) =>
      item.hashedimg === hashed &&
      item.size === custom.size &&
      item.category === category
  );

  if (productExists) {
    console.log("product already in cart");
    setExists(true);
    return;
  }

  await setDoc(
    dbuserdoc.ref,
    { cart: [...dbcart, custom] },
    { merge: true }
  );
  console.log("product added");
}
else {
  const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

  const productExists = storedCart.some(
    (item) =>
      item.hashedimg === hashed &&
      item.size === custom.size &&
      item.category === category
  );
  if (productExists) {
    console.log("product already in cart");
    setExists(true);
    return;
  }
  storedCart.push(custom);
  localStorage.setItem("cart", JSON.stringify(storedCart));
  console.log("product added");
}
};

    // navigate('/cart', { state: { customproduct: custom } });
  // };

  return (
    <div className="page-content customproducts">
      <div className="container py-5" style={{ marginTop: '70px' }}>
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="card border-0 shadow-sm text-center" style={{ borderRadius: '16px' }}>
              <div className="card-body py-5 px-4">
                <h1 className="fw-bold mt-3 mb-2">Custom Designs</h1>

                <div className="mb-4">
                  <label htmlFor="productName" className="form-label w-100 text-start">Product name:</label>
                  <input
                    type="text"
                    id="productName"
                    className="form-control"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    placeholder="e.g. My Custom Sticker"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="customType" className="form-label w-100 text-start">Choose your product type:</label>
                  <select
                    id="customType"
                    className="form-select"
                    value={customType}
                    onChange={(e) => {
                      setCustomType(e.target.value);
                      setStickerFile(null);
                      setFrameFile(null);
                      setFrameSize('');
                    }}
                  >
                    <option value="">-- Select --</option>
                    <option value="sticker">Sticker</option>
                    <option value="frame">Frame</option>
                  </select>
                </div>

                {customType === 'sticker' && (
                  <div className="mb-4">
                    <label className="form-label mb-2 w-100 text-start">Upload your design:</label>
                    <div className="square-upload">
                      {stickerPreview ? (
                        <img src={stickerPreview} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : stickerFile ? (
                        <span>{stickerFile.name}</span>
                      ) : (
                        <span>Click to choose image</span>
                      )}
                      <input type="file" accept="image/*" onChange={(e) => setStickerFile(e.target.files[0] || null)} />
                    </div>
                  </div>
                )}

                {customType === 'frame' && (
                  <>
                    <div className="mb-4">
                      <label htmlFor="frameSize" className="form-label w-100 text-start">Select frame size:</label>
                      <select
                        id="frameSize"
                        className="form-select"
                        value={frameSize}
                        onChange={(e) => setFrameSize(e.target.value)}
                      >
                        <option value="">-- Select size --</option>
                        <option value="20x30">20 × 30</option>
                        <option value="30x40">30 × 40</option>
                      </select>
                    </div>

                    {frameSize && (
                    <div className="mb-4">
  {/* <label className="form-label mb-2">Upload your design:</label> */}
  <div
    className="frame-upload"
    style={{
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      aspectRatio: '2 / 3', // optional: keeps frame proportion
      border: '1px solid #ccc',
      borderRadius: '8px',
      overflow: 'hidden',
    }}
  >
    {/* Empty Frame */}
    <img
      src={EmptyFrame}
      alt="empty frame"
      style={{
        width: '100%',
        height: '100%',
        display: 'block',
        objectFit: 'cover',
      }}
    />

    {/* Overlay user frame image */}
    {framePreview && (
      <>

      <img
        src={framePreview}
        alt="overlay"
        style={{
          position: 'absolute',
          top: '20%',     // adjust as needed
          left: '30%',    // adjust as needed
          width: '41%',   // adjust as needed
          height: '59%',  // adjust as needed
          objectFit: 'cover',
          pointerEvents: 'none', // lets clicks pass through
        }}
      /></>
    )}
  </div>

  {/* Input for file upload */}
 <div className="mb-4 mt-4">
  <input
    type="file"
    accept="image/*"
    id="frameFileInput"
    style={{ display: 'none' }}
    onChange={(e) => setFrameFile(e.target.files[0] || null)}
  />

  <button
    type="button"
    className="btn checkout mb-2"
    onClick={() => document.getElementById('frameFileInput').click()}
  >
    {frameFile ? "Change Your Image" : "Add Your Image"}
  </button>
</div>
</div>
                    )}
                  </>
                )}

        <button
  type="button"
  className="btn checkout mb-2"
  disabled={
    !productName ||
    !customType ||
    (customType === 'sticker' && !stickerFile) ||
    (customType === 'frame' && (!frameSize || !frameFile))
  }
  onClick={()=>{addFinalProductToCart(); navigate('/cart');}}
>
  Add to cart
</button>
                <br />
                <Link to="/" className="btn btn-link">Back to Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}